import { normalizeSectorName } from "./normalizeSectorName";

/**
 * resolveRegionCode
 *
 * ULTRA-SIMPLE VERSION:
 *  - Normalize sector
 *  - Extract leading letters
 *  - Return EXACT prefix (no mapping)
 *  - If anything fails → return "PR"
 */
export function resolveRegionCode(raw) {
  const sector = normalizeSectorName(raw);
  if (!sector) return "PR";

  const cleaned = sector.toUpperCase();

  // Extract letters only (e.g. "LS6" → "LS")
  const prefix = cleaned.match(/^[A-Z]+/)?.[0];
  if (!prefix) return "PR";

  return prefix;
}
